<div class="innerBanner" [style.background-image]="'url(' + highLights.bannerImage + ')'" (click)="imageClick(0)">
  <div class="copyright container cr-caption">
    <i class="fas fa-camera-retro" *ngIf="highLights.imgCredit !== ''"></i>
    <small>
      <span *ngIf="highLights.imgCredit !== ''">{{ highLights.imgCredit }}</span>
    </small>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <div class="row">
    <div class="contentPanel col-md-12 mb-3">
      <div class="pageTitle pb-2">
        <!-- <h3 class="mt-2">{{ highLights.bannerTitle }}</h3> -->
        <h1 class="mt-2 blogTitle">{{ highLights.bannerTitle }}</h1>
        <div class="blogAuthorInfo">
          <div *ngIf="highLights.specialInterestName" class="specialIntrest margintop-10">
            <i class="{{ highLights.specialIntersetIcon }}"></i>
            <span>{{ highLights.specialInterestName | translate }}</span>
          </div>
          <div *ngIf="highLights.authorName" class="margintop-10">
            <i class="fas fa-feather-alt"></i>
            <span>{{ highLights.authorName }}</span>
          </div>
          <div class="calendar margintop-10">
            <i class="far fa-calendar"></i>
            <span *ngIf="!highLights.updatedDate; else showUpdatedDate">
              {{ highLights.createdDate | date: 'dd MMMM y' }}
            </span>
            <ng-template #showUpdatedDate>
              <span> Last updated: {{ highLights.updatedDate | date: 'dd MMMM y' }} </span>
            </ng-template>
          </div>
          <div class="likediv">
            <div class="likebtn mr-2">
              <app-share-popup [data]="shareData"></app-share-popup>
            </div>
            <div class="likebtn">
              <p-toggleButton
                (click)="likeClick()"
                styleClass="likebutton"
                [(ngModel)]="like"
                onLabel="{{ 'Like' | translate }}"
                offLabel="{{ 'Like' | translate }}"
                offIcon="pi pi-thumbs-up"
                onIcon="pi pi-thumbs-up"
              ></p-toggleButton>
              <div class="chat-bubble" *ngIf="likeError">
                <button class="textClose" (click)="closePopup()">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="chat-bubble-message koko-text">{{ 'Please Sign in' | translate }}</div>
              </div>
            </div>
            <div class="likecount" *ngIf="likesData.like_count != 0">
              {{ likesData.like_count }} {{ 'people Liked this' | translate }}.
            </div>
            <!-- <div class="text-danger position-absolute likeerror" *ngIf="likeError">
              <i class="fa fa-solid fa-exclamation"></i>
              You need to be signed in to like this blog.
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="contentPanel col-md-12 mb-3">
      <p [innerHTML]="highLights.bannerContent" class="mb-1"></p>
      <p [innerHTML]="highLights.description_2" class="mb-1 mt-3"></p>

      <!-- <div *ngFor="let gallery of highLights.gallery; let imageIndex = index" class="mb-5 relative">
        <div class="imgCenterOne" *ngIf="gallery.url !== ''">
          <img src="{{ gallery.url }}" style="cursor: pointer" width="100%" />
        </div>
        <div *ngIf="gallery.imgCaption !== ''">
          <i>{{ gallery.imgCaption }}</i>
        </div>
        <div class="copyright container blog-pic-caption" *ngIf="gallery.url !== '' && gallery.imgCredit !== ''">
          <i class="fas fa-camera-retro"></i>
          <small>
            <span *ngIf="gallery.imgCredit !== ''">{{ gallery.imgCredit }}</span>
          </small>
        </div>
      </div> -->

      <div class="mb-5" id="secondary-gallery-container">
        <div class="secondary-gallery" *ngIf="highLights.gallery.length > 0">
          <div class="gallery-sizer"></div>
          <div class="gutter-gallery-sizer"></div>
          <div
            class="secondary-gallery-item"
            (click)="galleryItemClick(galleryIndex)"
            *ngFor="let gallery of highLights.gallery; let galleryIndex = index"
          >
            <div class="imgCenterOne" *ngIf="gallery.url !== ''">
              <img src="{{ gallery.url }}" style="cursor: pointer" width="100%" />
            </div>
            <div
              class="copyright container blog-pic-caption"
              style="bottom: 0px"
              *ngIf="gallery.url !== '' && gallery.imgCredit !== ''"
            >
              <i class="fas fa-camera-retro"></i>
              <small>
                <span *ngIf="gallery.imgCredit !== ''">{{ gallery.imgCredit }}</span>
              </small>
              <br />

              <div *ngIf="gallery.imgCaption !== ''">
                <i>{{ gallery.imgCaption }}</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="contentPanel col-md-12 mb-3">
          <div class="placesToSee blog" style="margin: 0px"
            *ngIf="highLights && highLights.gallery && highLights.gallery.length > 0">
            <div class="popular-items">
              <p-carousel [value]="highLights.gallery" styleClass="custom-carousel" [numVisible]="4" [numScroll]="1"
                [circular]="true" [responsiveOptions]="responsiveOptions" [ngClass]="lang">
                <ng-template let-product pTemplate="item">
                  <div class="product-item slider-arrow">
                    <div class="product-item-content">
                      <div class="image parr-image" [style.background-image]="'url(' + product.url + ')'">
                        <img [src]="" [alt]="" class="product-image slider-image" />
                      </div>
                      <div class="title" *ngIf="product.imgCaption">
                        <span>{{ product.imgCaption}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text mt-2 aquacolor">
                    <p>{{ product.imgCredit }}</p>
                  </div>
                </ng-template>
              </p-carousel>
            </div>
          </div>
        </div>
      </div> -->
      <p-galleria
        [(value)]="highLights.gallery"
        [(visible)]="galleryDisplayCustom"
        [(activeIndex)]="galleryActiveIndex"
        [fullScreen]="true"
        [showItemNavigators]="true"
        [baseZIndex]="100000"
        [containerStyle]="{ 'max-width': '90%' }"
      >
        <ng-template pTemplate="item" let-item>
          <img [src]="item.url" class="gallery-image" />
        </ng-template>
      </p-galleria>
    </div>
  </div>
  <div class="mb-5" id="secondary-images-container">
    <div class="secondary-image" *ngIf="highLights.moreImages.length > 0">
      <div class="grid-sizer"></div>
      <div class="gutter-sizer"></div>
      <div
        class="secondary-image-item"
        (click)="imageItemClick(imageIndex)"
        *ngFor="let gallery of highLights.moreImages; let imageIndex = index"
      >
        <img src="{{ gallery.url }}" style="width: 100%" />
      </div>
    </div>
  </div>
  <p-galleria
    [(value)]="highLights.moreImages"
    [(visible)]="imageDisplayCustom"
    [(activeIndex)]="imageActiveIndex"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [baseZIndex]="100000"
    [containerStyle]="{ 'max-width': '90%' }"
  >
    <ng-template pTemplate="item" let-item>
      <img [src]="item.url" class="gallery-image" />
    </ng-template>
  </p-galleria>
  <div class="row mb-5">
    <div *ngFor="let video of highLights.moreVideos; let videoIndex = index" class="contentPanel col-md-6 relative">
      <div class="imgCenterOne mb-4" *ngIf="video.url !== '' && isYoutubeVideoUrl(video.url)">
        <iframe
          style="width: 100%; aspect-ratio: 16 / 9"
          [src]="video.embedUrl"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>

  <div class="card-columns">
    <div class="card" *ngFor="let person of crowdriff_images; let imageIndex = index" (click)="cimageClick(imageIndex)">
      <img class="card-img-top" src="{{ person.value.thumbnail_gallery }}" alt="Card image cap" />
    </div>
  </div>

  <p-galleria
    [(value)]="crowdriff_images"
    [(visible)]="displayCustomc"
    [(activeIndex)]="activeIndexc"
    [fullScreen]="true"
    [showItemNavigators]="false"
    [baseZIndex]="100000"
    [containerStyle]="{ 'max-width': '90%' }"
  >
    <ng-template pTemplate="item" let-item>
      <img [src]="item.value.thumbnail_fullscreen" class="gallery-image" />
      <div class="copyright container cr-caption">
        <i class="fas fa-camera-retro" *ngIf="item.value.image_fullscreen !== ''"></i>
        <small>
          <span *ngIf="item.value.userName !== ''">{{ item.value.userName }} </span>
          <span *ngIf="item.value.text !== ''">, {{ item.value.text }}</span>
        </small>
        <br />
        <small *ngFor="let keywords of item.value.keywords; last as isLast">
          <span>{{ keywords }} <span *ngIf="!isLast">,</span></span>
        </small>
      </div>
    </ng-template>
  </p-galleria>

  <div class="row">
    <div class="contentPanel col-md-12 mb-3">
      <div
        class="placesToSee blog"
        style="margin: 0px"
        *ngIf="highLights && highLights.relatedBlogs && highLights.relatedBlogs.length > 0"
      >
        <!-- <h1 class="heading">{{ 'RelatedBlogs' | translate }}</h1> -->
        <span class="heading">{{ 'RelatedBlogs' | translate }}</span>
        <div class="">
          <p-carousel
            [value]="highLights.relatedBlogs"
            styleClass="custom-carousel"
            [numVisible]="4"
            [numScroll]="1"
            [circular]="true"
            [responsiveOptions]="responsiveOptions"
            [ngClass]="lang"
          >
            <ng-template let-product pTemplate="item">
              <a class="product-item slider-arrow" target="_blank" [href]="getBlogUrl(product)">
                <div class="product-item-content">
                  <div class="image parr-image">
                    <img [src]="product.uri" [alt]="product.specialInterestName" class="popular-img" />
                  </div>
                  <div class="title" *ngIf="product.specialInterestName">
                    <i class="{{ product.specialIntersetIcon }}"></i>
                    <span>{{ product.specialInterestName | translate | uppercase }}</span>
                  </div>
                </div>
              </a>
              <a class="text mt-2 aquacolor product-a" target="_blank" [href]="getBlogUrl(product)">
                <p>{{ product.title }}</p>
              </a>
            </ng-template>
          </p-carousel>
        </div>
      </div>
    </div>
  </div>
</div>
